
import React from 'react';
import './App.css';
import SearchInst from "./searchInst"

function App() {
  return (
    <div className="App">
     
 <div className="container">
        <h1 className="title">PhotoSearch App </h1>

	<p>A simple webapp allowing to search for images by their semantic contents. You can access the generated captions by hovering on the images. 
  The photos are from the National Geographic instagram account.</p>
	<p>The captions are generated using a CNN + RNN model, which I describe <a href="https://tidiane-camaret.github.io/computer_vision/encoder_decoder/2021/04/18/computer-vision-image-captioning-en.html">on my blog. </a>
	<p>You can also check a description of the project <a href="https://tidiane-camaret.github.io/computer_vision/react/python/data_science/2021/03/23/computer-vision-project-image-searcher-en.html">here.</a></p>
  <p>Github project for the front part is available here :  <a href="https://github.com/tidiane-camaret/photosearch-front">https://github.com/tidiane-camaret/photosearch-front</a></p>
</p>
        <SearchInst /> 
        </div>
    </div>
  );
}
export default App;
